<sgt-multi-select
  [options]="options"
  [settings]="settings"
  [(ngModel)]="idsCondicoesPagamentos"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()"
  (isFirstOpened)="firstOpened($event)">
</sgt-multi-select>
